import { JSONStringList } from "./misc";

export const strings: JSONStringList = {
	en: {
		homePage: {
			title: "Math memory",
			start: "Start",
		},
		gameSelectPage: {
			addition: "Addition",
			multiplication: "Multiplication",
			subtraction: "Subtraction",
			division: "Division",
		},
		settingsPage: {
			en: "English",
			hr: "Croatian",
			de: "German",
		},
		errorPage: {
			notFound: "Page not found",
		},
		misc: {
			loading: "Loading",
			congrats: "Congratulations",
		},
	},
	hr: {
		homePage: {
			title: "Matematički memory",
			start: "Započni",
		},
		gameSelectPage: {
			addition: "Zbrajanje",
			multiplication: "Množenje",
			subtraction: "Oduzimanje",
			division: "Dijeljenje",
		},
		settingsPage: {
			en: "Engleski",
			hr: "Hrvatski",
			de: "Njemački",
		},
		errorPage: {
			notFound: "Stranica nije pronađena",
		},
		misc: {
			loading: "Učitavanje",
			congrats: "Čestitamo",
		},
	},
	de: {
		homePage: {
			title: "Mathematisches Memory Spiel",
			start: "Starten",
		},
		gameSelectPage: {
			addition: "Addition",
			multiplication: "Multiplikation",
			subtraction: "Subtraktion",
			division: "Division",
		},
		settingsPage: {
			en: "Englisch",
			hr: "Kroatisch",
			de: "Deutsch",
		},
		errorPage: {
			notFound: "Seite nicht gefunden",
		},
		misc: {
			loading: "Wird geladen",
			congrats: "Glückwunsch",
		},
	},
};
